<!--
 * @FileDescription: 新闻分页
 * @Author: liangjz
 * @Date: 2022.4.13
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div :class="[listType == 'imgList' ? 'imgList' : listType, 'comList']">
    <el-empty v-if="List.length <= 0" description="暂无文章╮(╯▽╰)╭"></el-empty>
    <ul v-else class="comUl">
      <li class="Item" v-for="(item, index) in List" :key="index">
        <router-link
          :to="{
            path: '/' + baseDetailsUrl,
            query: { id: item.infoId, infoColumn: infoColumn },
          }"
        >
          <template v-if="listType == 'imgList'">
            <div class="newsImg fl">
              <!-- <img :src="item.infoImage" alt="..." /> -->
              <img :src="item.infoImage ? ImgSrc(item) : ''" alt="..." />
            </div>
            <div class="newstxtcon fl">
              <div class="news_tit">
                <div class="textSl1">
                  {{ item.infoName }}
                </div>
              </div>
              <div class="news_fcon">
                {{ item.infoContent }}
              </div>
              <div class="newsbtm">
                <div class="newstime">
                  <span>
                    {{ item.publishTime }}
                  </span>
                </div>
                <div class="news_detai">
                  <span>查看详情>></span>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="i_time">
              <div class="b_time_a">{{ item.showTime[0] }}</div>
              <div class="b_time_b">{{ item.showTime[1] }}</div>
            </div>
            <div class="i_main">
              <div class="m_title textslh">
                {{ item.infoName }}
              </div>
              <div class="m_desc" v-html="item.infoContent"></div>
              <div class="btn_more">查看详情>></div>
            </div>
          </template>
        </router-link>
      </li>
    </ul>
    <div class="pagination" v-if="Total > PageSize">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="PageSize"
        :total="Total"
        @size-change="getPage"
        @current-change="getPage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "comList",
  props: [
    "infoColumn",
    "Total",
    "PageNo",
    "PageSize",
    "baseDetailsUrl",
    "listType",
  ],
  data() {
    return {
      List: [],
    };
  },
  created() {
    this.getInfoManageList();
  },
  mounted() {},
  methods: {
    // 时间拆分

    conversionFun(date) {
      // console.log(date);
      var nDate = new Date(date.replace(new RegExp(/-/gm), "/"));
      // let nDate = new Date(date),
      var y = nDate.getFullYear(),
        m = ("0" + (nDate.getMonth() + 1)).slice(-2),
        d = ("0" + nDate.getDate()).slice(-2);
      // console.log(date)
      return [y + "." + m, d];
    },
    onConversion2(date) {
      // console.log(date);
      var nDate = new Date(date.replace(new RegExp(/-/gm), "/"));
      // let nDate = new Date(date),
      var y = nDate.getFullYear(),
        m = ("0" + (nDate.getMonth() + 1)).slice(-2),
        d = ("0" + nDate.getDate()).slice(-2);
      // console.log(date)
      return y + "-" + m + "-" + d;
    },
    // url拼接
    splicingUrl({ base, index, type }) {
      return base + "&index=" + index + "&type=" + type;
    },
    // 图片路径拼接
    ImgSrc(item) {
      return item && item.infoImage
        ? this.$store.state.baseUrl + item.infoImage
        : "";
    },
    //移除html标签
    removeHTMLTag(str) {
      var re1 = new RegExp("<.+?>", "g"); //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var msg = str.replace(re1, ""); //执行替换成空字符
      msg = msg.replace(/&nbsp;/gi, "");
      msg = msg.replace(/&rdquo;/gi, "");
      msg = msg.replace(/&ldquo;/gi, "");
      return msg;
    },
    // 获取问卷调查
    async getInfoManageList() {
      let _that = this;
      let res = await this.$request.getInfoManageList({
        pageNo: this.PageNo,
        pageSize: this.PageSize,
        infoColumn: this.infoColumn,
      });
      res.rows.map((val) => {
        val.infoContent = _that.removeHTMLTag(val.infoContent);
        val.showTime = val.publishTime
          ?  _that.conversionFun(val.publishTime)
          : [];
      });
      // console.log(res.rows);
      this.List = res.rows;
      this.$emit("update:total", res.total);
    },
    getPage(page) {
      // 获取第 page 页数据
      // console.log(page);
      this.$emit("update:PageNo", page);
      this.$nextTick(() => {
        this.getInfoManageList();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$themeColor: #003b99;
$themeMinWidth: 1180px;
.textslh {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.comList {
  width: $themeMinWidth;
  box-sizing: border-box;
  padding: 0 60px;
  margin: -134px auto 50px;
  border: solid 1px #e8e8e8;
  position: relative;
  z-index: 666;
  background: #ffffff;
  &::before {
    content: "";
    display: block;
    width: 33px;
    height: 15px;
    background: url("../../assets/img/common/icon_sanjiao.png") top center
      no-repeat;
    background-size: cover;
    position: absolute;
    top: -13px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 66;
  }
  &.imgList {
    padding: 0 20px;
    .comUl .Item {
      &:hover a .newstxtcon .news_tit {
        color: $themeColor;
      }
      a {
        display: flex;
        .newsImg {
          flex-shrink: 0;
          width: 310px;
          height: 186px;
          margin: 0 30px 0 0;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .newstxtcon {
          flex: 1;
          .news_tit {
            font-size: 18px;
            line-height: 30px;
            color: #333333;
            margin: 0 0 20px 0;
          }
          .news_fcon {
            font-size: 16px;
            line-height: 30px;
            color: #666666;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            text-align: justify;
            margin: 0 0 20px 0;
          }
          .newsbtm {
            display: flex;
            justify-content: space-between;
            .newstime {
              font-size: 16px;
              line-height: 26px;
              color: #666666;
            }
            .news_detai {
              font-size: 16px;
              line-height: 26px;
              color: #003b99;
            }
          }
        }
      }
    }
  }

  .comUl {
    position: relative;
    .Item {
      border-bottom: 1px solid #e6e6e6;
      &:last-child {
        border-bottom: none;
      }
      &:hover a .i_main .m_title {
        color: $themeColor;
      }

      a {
        display: flex;
        padding: 46px 0 30px;
        .i_time {
          width: 80px;
          height: 66px;
          background-color: #f8f8fb;
          text-align: center;
          .b_time_a {
            width: 78px;
            height: 26px;
            line-height: 26px;
            background-color: $themeColor;
            font-size: 16px;
            font-weight: bold;
            color: #ffffff;
          }
          .b_time_b {
            height: 40px;
            line-height: 40px;
            font-size: 24px;
            font-weight: bold;
            color: #333333;
          }
        }
        .i_main {
          width: 980px;
          box-sizing: border-box;
          padding: 0 0 0 70px;
          .m_title {
            font-size: 18px;
            height: 30px;
            line-height: 30px;
            // font-weight: bold;
            color: #333333;
            padding: 0 0 30px 0;
          }
          .m_desc {
            line-height: 24px;
            font-size: 16px;
            color: #666666;
            text-align: justify;
            margin: 0 0 20px 0;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          .btn_more {
            float: right;
            font-size: 16px;
            line-height: 26px;
            color: $themeColor;
          }
        }
      }
    }
  }
  .pagination {
    text-align: center;
    padding: 40px 0;
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: $themeColor;
    }
  }
}
</style>
